// pages/HomePage.js
import React from 'react';
import Services from '../components/ServicesPage/Services';
import Footer from '../components/Footer';


function ServicesPage() {
  return (
    <div>
      <Services/>
      <Footer/>
    </div>
  );
}

export default ServicesPage;
